export const CONFIG = {
	SENTRY_DSN: "",
	SENTRY_ORG: "",
	SENTRY_PROJECT: "",
	SENTRY_RELEASE_TIMESTAMP: "",
};
